export default __webpack_public_path__ + "static/media/pure-water.b6b93042.png";